import unique from '../../parser/route/unique';

export const getComponents = props => ({
    'header-preconnect-0': {
      name: `Preconnect`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        list: [
          `https://wx.mlcdn.com.br`,
          `https://6590300.fls.doubleclick.net`,
          `https://a-static.mlcdn.com.br`,
          `https://ad.doubleclick.net`,
          `https://analytics.pangle-ads.com`,
          `https://analytics.tiktok.com`,
          `https://analytics.twitter.com`,
          `https://bat.bing.com`,
          `https://c.bing.com`,
          `https://c.clarity.ms`,
          `https://cas.avalon.perfdrive.com`,
          `https://cdn.perfdrive.com`,
          `https://connect.facebook.net`,
          `https://ct.pinterest.com`,
          `https://d.clarity.ms`,
          `https://gum.criteo.com`,
          `https://i.btg360.com.br`,
          `https://s.pinimg.com`,
          `https://sc-static.net`,
          `https://script.hotjar.com`,
          `https://site-content.magazineluiza.com.br`,
          `https://static.ads-twitter.com`,
          `https://static.criteo.net`,
          `https://static.hotjar.com`,
          `https://t.co`,
          `https://tags.creativecdn.com`,
          `https://td.doubleclick.net`,
          `https://tom.mlcdn.com.br`,
          `https://tr.snapchat.com`,
          `https://tr6.snapchat.com`,
          `https://us.creativecdn.com`,
          `https://www.clarity.ms`,
          `https://www.facebook.com`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-preconnect-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-script-1': {
      name: `Script`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        src: `https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-script-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-all-in-2': {
      name: `AllIn`,
      from: `@magalu/ecomm-components/rave/scripts/AllIn`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-all-in-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-criteo-3': {
      name: `Criteo`,
      from: `@magalu/ecomm-components/rave/scripts/Criteo`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-criteo-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-tik-tok-4': {
      name: `TikTok`,
      from: `@magalu/ecomm-components/rave/scripts/TikTok`,
      props: {
        id: `C1I87V1T0U322RQPSRKG`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-tik-tok-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-rtbhouse-5': {
      name: `RTBHouse`,
      from: `@magalu/ecomm-components/rave/scripts/RTBHouse`,
      props: {
        id: `msWukR4UlwKQouZSY8IT`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-rtbhouse-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-stewie-6': {
      name: `Stewie`,
      from: `@magalu/ecomm-components/rave/scripts/Stewie`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-stewie-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-spotify-ad-analytics-7': {
      name: `SpotifyAdAnalytics`,
      from: `@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics`,
      props: {
        id: `66f417c2d2344c0980e19d4e7f996073`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-spotify-ad-analytics-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-hotjar-8': {
      name: `Hotjar`,
      from: `@magalu/ecomm-components/rave/scripts/Hotjar`,
      props: {
        id: `4936838`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-hotjar-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-9': {
      name: `Loader`,
      from: `@magalu/ecomm-components/rave/Loader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-9`,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-10': {
      name: `StateLoader`,
      from: `@magalu/ecomm-components/rave/StateLoader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-10`,
      spacing: {
      },
      ssr: false,
    },
    'header-event-page-view-dispatcher-11': {
      name: `EventPageViewDispatcher`,
      from: `@magalu/ecomm-components/rave/EventPageViewDispatcher`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-event-page-view-dispatcher-11`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-9-children-page-loading-0': {
      name: `PageLoading`,
      from: `@magalu/ecomm-components/components/PageLoading`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-9-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-state-loader-10-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-10-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-zip-code-bar-0': {
      name: `ZipCodeBar`,
      from: `@magalu/ecomm-components/rave/ZipCodeBar`,
      ssr: false,
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-zip-code-bar-0`,
      placeholder: undefined,
      spacing: {
      },
    },
    'content-zip-code-modal-1': {
      name: `ZipCodeModal`,
      from: `@magalu/ecomm-components/rave/ZipCodeModal`,
      ssr: false,
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-zip-code-modal-1`,
      placeholder: undefined,
      spacing: {
      },
    },
    'content-tagless-ad-unit-2': {
      name: `TaglessAdUnit`,
      from: `@magalu/ecomm-components/rave/TaglessAdUnit`,
      ssr: false,
      props: {
        path: `/21908074511/mobile/discovery_padrao/home_mobile/Carrossel/x01_c`,
        size: [
          684,
          352,
        ],
      },
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-tagless-ad-unit-2`,
      placeholder: undefined,
      spacing: {
      },
    },
    'content-tagless-ad-unit-3': {
      name: `TaglessAdUnit`,
      from: `@magalu/ecomm-components/rave/TaglessAdUnit`,
      ssr: false,
      props: {
        path: `/21908074511/mobile/discovery_padrao/home_mobile/fixos/x04`,
        size: [
          650,
          402,
        ],
      },
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-tagless-ad-unit-3`,
      placeholder: undefined,
      spacing: {
      },
    },
    'content-tagless-ad-unit-4': {
      name: `TaglessAdUnit`,
      from: `@magalu/ecomm-components/rave/TaglessAdUnit`,
      ssr: false,
      props: {
        path: `/21908074511/mobile/discovery_padrao/home_mobile/fixos/x05`,
        size: [
          650,
          402,
        ],
      },
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-tagless-ad-unit-4`,
      placeholder: undefined,
      spacing: {
      },
    },
    'content-tagless-ad-unit-5': {
      name: `TaglessAdUnit`,
      from: `@magalu/ecomm-components/rave/TaglessAdUnit`,
      ssr: false,
      props: {
        path: `/21908074511/mobile/discovery_padrao/home_mobile/fixos/x06`,
        size: [
          650,
          402,
        ],
      },
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-tagless-ad-unit-5`,
      placeholder: undefined,
      spacing: {
      },
    },
    'content-tagless-ad-unit-6': {
      name: `TaglessAdUnit`,
      from: `@magalu/ecomm-components/rave/TaglessAdUnit`,
      ssr: false,
      props: {
        path: `/21908074511/mobile/discovery_padrao/home_mobile/fixos/x07`,
        size: [
          650,
          402,
        ],
      },
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-tagless-ad-unit-6`,
      placeholder: undefined,
      spacing: {
      },
    },
    'content-tagless-ad-unit-7': {
      name: `TaglessAdUnit`,
      from: `@magalu/ecomm-components/rave/TaglessAdUnit`,
      ssr: false,
      props: {
        path: `/21908074511/mobile/discovery_padrao/home_mobile/fixos/x08`,
        size: [
          650,
          402,
        ],
      },
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-tagless-ad-unit-7`,
      placeholder: undefined,
      spacing: {
      },
    },
    'content-term-list-8': {
      name: `TermList`,
      from: `@magalu/ecomm-components/rave/TermList`,
      show: props?.data?.homePageContent?.linkList,
      props: {
        titleAs: `h2`,
        title: `Links relacionados`,
        terms: props?.data?.homePageContent?.linkList,
        typeList: `inline`,
        showAllItems: false,
        limitListItems: 10,
        className: `px-md py-lg bg-brand-darker text-on-brand-darker font-xsm-regular`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-term-list-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-version-tag-0': {
      name: `VersionTag`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `footer-version-tag-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-back-to-top-1': {
      name: `BackToTop`,
      from: `@magalu/ecomm-components/components/BackToTop`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `footer-back-to-top-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
  });

export const dataSource = {
  "graphql": {
    "configsDir": "config",
    "host": "https://federation.magazineluiza.com.br",
    "timeout": 5000
  }
}

export const getHeadProps = (props) => ({
    links: [
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/fonts/magalu-ui-variable/files/MagaluUIVariable.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/truetype`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.ttf`,
        crossOrigin: ``,
      },
    ],
    meta: [
      {
        name: `viewport`,
        content: `width=device-width, initial-scale=1.0, user-scalable=no, maximum-scale=1.0`,
      },
    ],
  });

export const componentsList = [
  "Preconnect",
  "Script",
  "AllIn",
  "Criteo",
  "TikTok",
  "RTBHouse",
  "Stewie",
  "SpotifyAdAnalytics",
  "Hotjar",
  "Loader",
  "StateLoader",
  "EventPageViewDispatcher",
  "PageLoading",
  "ZipCodeBar",
  "ZipCodeModal",
  "TaglessAdUnit",
  "TermList",
  "VersionTag",
  "BackToTop"
];

export const routeInfo = {
  id: 'home',
  name: 'home',
  pathPattern: '/',
  pathAliases: {},
  parser: {
    query: {
      "seller_id": unique(),
    },
    cookie: {},
  },
  renderMethod: 'SSR',
  forwardCookies: '',
  forwardHeaders: 'user-agent,referer,theme,x-forwarded-for'
};

export const manifest = {
  "useTypescript": true,
  "deepLinkHost": "https://m.magazineluiza.com.br",
  "isMiniApp": true
};

export const getGlobalClassName = props => ([
  ]).join(' ').trim();

export const getPageVariables = props => ({
    homePageContent_site: `magazineluiza-mobile`,
    homePageContent_includeMeta: true,
    homePageContent_includeHotlinks: true,
    homePageContent_includeLinkList: true,
  });

export const middlewaresArgs = ({ 
      "getAppTheme": (props) => ({
  }),
      "getUserInfo": (props) => ({
  }),
      "getVersions": (props) => ({
  }),
      "writePromoterIdCookie": (props) => ({
  }),
 });

export const config = {
  assetPrefix: '',
};
